import React from 'react';
import ApiValidationErrorDisplay from '~/components/ApiValidationErrorDisplay';
import { clearApiValidationErrors } from '~/stores/redux/common/apiValidationErrorSlice';
import { schema } from './passive.yup';
import DisplayFormikState from '~/components/DisplayFormikState';
import SubmitResetButtons from '~/components/FormControl/SubmitResetButtons';
import classNames from 'classnames/bind';
const cx = classNames.bind();
import { Formik } from 'formik';
import { Card, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import BasicDetail from './BasicDetail';
import Damage from './Damage';
import DiceValue from './DiceValue';
import HealthPoint from './HealthPoint';
import NumberOfUpgrade from './NumberOfUpgrade';
import Point from './Point';
import ActiveRounds from '../../components/ActiveRounds/ActiveRounds';

function PassiveForm({ initialValues, formSubmit }) {
    const { isLoading } = useSelector((state) => state.loading);
    const { apiValidationErrors } = useSelector((state) => state.apiValidationError);

    return (
        <>
            {!isEmpty(initialValues) ? (
                <Card>
                    <Card.Body>
                        <Formik
                            initialValues={initialValues}
                            validateOnChange={false}
                            validationSchema={schema}
                            onSubmit={formSubmit}
                        >
                            {(props) => {
                                // eslint-disable-next-line react/prop-types
                                const { handleSubmit, isSubmitting, resetForm } = props;

                                return (
                                    <>
                                        <SubmitResetButtons
                                            isSubmitting={isSubmitting}
                                            handleSubmit={handleSubmit}
                                            resetForm={resetForm}
                                        />
                                        <BasicDetail />

                                        <Row>
                                            <Damage />
                                            <DiceValue />
                                        </Row>

                                        <Row>
                                            <HealthPoint />
                                            <Point />
                                        </Row>

                                        <Row>
                                            <NumberOfUpgrade />
                                            <ActiveRounds />
                                        </Row>

                                        <SubmitResetButtons
                                            isSubmitting={isSubmitting}
                                            handleSubmit={handleSubmit}
                                            resetForm={resetForm}
                                        />
                                        <ApiValidationErrorDisplay
                                            errors={apiValidationErrors}
                                            clearError={clearApiValidationErrors}
                                        />
                                        <DisplayFormikState props={props} />
                                    </>
                                );
                            }}
                        </Formik>
                    </Card.Body>
                </Card>
            ) : (
                <Card style={{ position: 'relative' }}>
                    <Card.Body className={cx('row', { whirl: isLoading })}></Card.Body>
                </Card>
            )}
        </>
    );
}

PassiveForm.propTypes = {
    initialValues: PropTypes.object.isRequired,
    formSubmit: PropTypes.func.isRequired,
};

export default PassiveForm;
